var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { USER_INFO_REQUEST } from '../../reducers/common';
import { getCookie, setCookie } from '../../utils/util';
import GridResponse from '../grid_response';
import Main from '../../components/main';
import Sub from '../../components/sub';
import Layer from '../../components/layer';
import AdultCheck from '../../components/adult_check';
import LoadScript from 'common/modules/loadScript';
var App = function () {
    var item = useSelector(function (state) { return state.product.item; });
    var _a = useState(null), adultCheck = _a[0], setAdultCheck = _a[1];
    var dispatch = useDispatch();
    var fetchUserInfo = useCallback(function () {
        dispatch({
            type: USER_INFO_REQUEST
        });
    }, []);
    var latestSet = function () {
        if (!item)
            return;
        var itemId = item.item_id;
        if (getCookie('latestItemView')) {
            var cookieItems = getCookie('latestItemView');
            var itemParse = JSON.parse(cookieItems || '');
            var itemFilter = itemParse.filter(function (v) { return v !== itemId; });
            itemFilter.unshift(itemId);
            var itemSlice = itemFilter.slice(0, 15); // 15개 까지 저장
            setCookie('latestItemView', JSON.stringify(itemSlice), (30 * 24 * 60 * 60), '/', ".pping.".concat(process.env.REACT_APP_TLD));
        }
        else {
            var newData = JSON.stringify([itemId]);
            setCookie('latestItemView', newData, (30 * 24 * 60 * 60), '/', ".pping.".concat(process.env.REACT_APP_TLD));
        }
    };
    useEffect(function () {
        fetchUserInfo();
    }, []);
    useEffect(function () {
        if (item) {
            latestSet();
        }
    }, [item]);
    useEffect(function () {
        //item값 변경시 성인 체크 item.cate_f_adult값 0,1 false 미성년
        if (item) {
            var adult = (item.cate_f_adult === 0 || item.user_f_adult === 1);
            setAdultCheck(adult);
            if (adult) {
                LoadScript("".concat(process.env.REACT_APP_CDN_JS, "/_pping/_gnb/v2102/aside_medium/static/js/main.js"));
            }
        }
    }, [item]);
    return (React.createElement(BrowserRouter, null,
        React.createElement(Style, { className: (item === null || item === void 0 ? void 0 : item.minishop) ? 'isMinishop' : '' },
            (adultCheck === null || adultCheck === true) ? (React.createElement(GridResponse, { main: 
                // Switch를 사용하면
                // BrowserRouter만 사용할 때와 다르게 하나의 매칭되는 요소만 렌더링한다는 점을 보장해줍니다.
                React.createElement(Switch, null,
                    React.createElement(Route, { path: "/detail/:item_id/:idx_b_manager", component: Main }),
                    React.createElement(Route, { path: "/detail/:item_id/:idx_b_manager", component: Main }),
                    React.createElement(Route, { path: "/detail/:item_id", component: Main }),
                    React.createElement(Route, { path: "*", component: Main })), sub: React.createElement(Sub, null) })) : (item && (
            // adultCheck false 면 성인 체크 해야함
            React.createElement(AdultCheck, { user_type: item.user_type, user_f_adult: item.user_f_adult }))),
            React.createElement(Layer, null))));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: 'Noto Sans KR', sans-serif;\n    font-size: 15px;\n    color: #333;\n\n    *,\n    *:before,\n    *:after {\n        box-sizing: border-box;\n    }\n    & > .indexAT {\n        margin-top: 30px;\n    }\n"], ["\n    font-family: 'Noto Sans KR', sans-serif;\n    font-size: 15px;\n    color: #333;\n\n    *,\n    *:before,\n    *:after {\n        box-sizing: border-box;\n    }\n    & > .indexAT {\n        margin-top: 30px;\n    }\n"])));
export default App;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/layouts/app/index.tsx
// module id = 166
// module chunks = 0